import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import dict from './modules/dict'
import user from './modules/user'
import tagsView from './modules/tagsView'
import permission from './modules/permission'
import getters from './getters'
import downLoadProgress from './modules/downLoadProgress'; // 导入 downLoadProgress 模块

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    dict,
    user,
    tagsView,
    permission,
    downLoadProgress,
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js